document.addEventListener('click', function (e) {
  const target = e.target;

  if (
    target.matches('button, a[target="_blank"], a.btn:not([href^="https://butcherboxforpets.com"], [href^="/"]), [data-track-click]')
  ) {
    let btnText = target.textContent || target.getAttribute('alt') || target.getAttribute('id');

    if (!btnText) {
      const img = target.querySelector('img');
      if (img) {
        btnText = img.getAttribute('alt');
      }
    }

    const trackClick = target.dataset.trackClick || btnText;

    const attrs = {};
    Array.from(target.attributes).forEach(attr => {
      attrs[attr.name] = target.getAttribute(attr.name);
    });

    amplitude.track("Clicked Button", {
      text: btnText,
      innerText: target.textContent,
      alt: target.getAttribute('alt'),
      id: target.getAttribute('id'),
      class: target.getAttribute('class'),
      trackClick: trackClick,
      url: window.location.href,
      domain: window.location.host,
      params: window.location.search.substring(1),
      hash: window.location.hash,
      path: window.location.pathname,
      attrs: attrs
    });
  }
});
